import { render } from "./AboutView.vue?vue&type=template&id=d54a8990"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=d54a8990&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\travelsite-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__